import { ReactElement, JSX } from 'react'

import { FeatureStatusTag } from 'components/FeatureStatusTag'
import { FeatureStatus } from 'components/FeatureStatusTag/FeatureStatusTag'
import { date } from 'configuration/dayjs'
import GroupByTooltip, {
    GroupByTooltipAlertType,
} from 'features/MetricsGlossary/components/GroupByTooltip'
import { DataSourceGroupBy } from 'features/MetricsGlossary/types'
import { elementToString } from 'helpers/utilities'
import { Field } from 'types'

interface GroupByNameProps {
    field?: Field<any>
    groupBy?: DataSourceGroupBy
    tooltipAlertMessage?: ReactElement | string
    tooltipAlertType?: GroupByTooltipAlertType
    addTooltip?: boolean
}

function GroupByName(props: GroupByNameProps): JSX.Element {
    const {
        field,
        groupBy,
        tooltipAlertMessage,
        tooltipAlertType,
        addTooltip = true,
    } = props

    const isDeprecated =
        groupBy?.metadata_is_deprecated ??
        field?.metricOptions?.isDeprecated ??
        false

    let featureStatus: FeatureStatus | undefined = isDeprecated
        ? 'deprecated'
        : undefined

    const groupByReleaseDate =
        groupBy?.metadata_release_date ??
        field?.metricOptions?.releaseDate ??
        null

    if (!isDeprecated && !!groupByReleaseDate) {
        const releaseDate = date(groupByReleaseDate, 'YYYY-MM-DD')
        if (releaseDate.isAfter(date().subtract(3, 'month'))) {
            featureStatus = 'new'
        }
    }

    return groupBy && addTooltip ? (
        <GroupByTooltip
            groupBy={groupBy}
            placement="right"
            alertMessage={tooltipAlertMessage}
            alertType={tooltipAlertType}
        >
            <span>
                {groupBy.display_name || '-'}
                {featureStatus && (
                    <>
                        {' '}
                        <FeatureStatusTag status={featureStatus} />
                    </>
                )}
            </span>
        </GroupByTooltip>
    ) : (
        <>
            {groupBy?.display_name ?? elementToString(field?.name ?? '-')}
            {featureStatus && (
                <>
                    {' '}
                    <FeatureStatusTag status={featureStatus} />
                </>
            )}
        </>
    )
}

export default GroupByName
